/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './pharmacy-stock-indent-item.reducer';

export const PharmacyStockIndentItemDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const pharmacyStockIndentItemEntity = useAppSelector(state => state.pharmacyStockIndentItem.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="pharmacyStockIndentItemDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.detail.title">PharmacyStockIndentItem</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.id">Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.id}</dd>
          <dt>
            <span id="indentStatus">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.indentStatus">Indent Status</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.indentStatus}</dd>
          <dt>
            <span id="indentedQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.indentedQty">Indented Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.indentedQty}</dd>
          <dt>
            <span id="fulfilledQty">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.fulfilledQty">Fulfilled Qty</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.fulfilledQty}</dd>
          <dt>
            <span id="packs">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.packs">Packs</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.packs}</dd>
          <dt>
            <span id="productType">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.productType">Product Type</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.productType}</dd>
          <dt>
            <span id="productId">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.productId">Product Id</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.productId}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.active">Active</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.cursor}</dd>
          <dt>
            <span id="lastUpdated">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.lastUpdated">Last Updated</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.lastUpdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.timestampEntry}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.pharmacyStockIndentItem.indent">Indent</Translate>
          </dt>
          <dd>{pharmacyStockIndentItemEntity.indent ? pharmacyStockIndentItemEntity.indent.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/pharmacy-stock-indent-item" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/pharmacy-stock-indent-item/${pharmacyStockIndentItemEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PharmacyStockIndentItemDetail;
